module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-get-start-financial"
  }, [_c('Intro', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-get-start-financial__container"
  }, _vm._l((_vm.props.text_box), function(info, i) {
    return _c('div', {
      staticClass: "custom-get-start-financial__text-box"
    }, [_c('v-waypoint', {
      staticClass: "custom-get-start-financial__waypoint",
      style: ({
        top: _vm.top * (i + 1) + "px"
      }),
      on: {
        "waypoint-in": function($event) {
          _vm.fadeUp(i)
        }
      }
    }), _c('div', {
      ref: "icon",
      refInFor: true,
      staticClass: "custom-get-start-financial__icon"
    }, [_c('Icon', {
      attrs: {
        "name": info.name
      }
    })], 1), _c('div', {
      staticClass: "custom-get-start-financial__text",
      domProps: {
        "innerHTML": _vm._s(info.text)
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a84f1e8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-get-start-financial/custom-get-start-financial.pug
// module id = 1116
// module chunks = 1